"use client";

import { useData } from "data/data-provider";
import EndDateTimeRange from "designs/Common/(car-search-form)/endDateTIme";
import StartDateTimeRange from "designs/Common/(car-search-form)/startDateTime";
import DropOffLocationInput from "designs/Common/DropOffLocationInput";
import LocationInput from "designs/Common/LocationInput";
import { set } from "lodash";
import { FC, useEffect } from "react";

export interface RentalCarSearchFormProps {}

const RentalCarSearchForm: FC<RentalCarSearchFormProps> = () => {
  const {
    setDropoffLocationType,
    dropoffLocationType,
    setSelectedWeeks,
    setSelectedMonth,
    setEndDate,
    setStartDate,
    setPickupLocation,
    setDropoffLocation,
  } = useData();

  useEffect(() => {
    setSelectedWeeks([]);
    setSelectedMonth(0);
    setStartDate(null);
    setEndDate(null);
    setPickupLocation(null);
    setDropoffLocation(null);
    setDropoffLocationType(true);
  }, []);

  const isDdropOffdifferent = dropoffLocationType === false;

  return (
    <form className="w-full relative mt-8 rounded-xl shadow-xl bg-secondary-50/80 backdrop-blur-sm">
      <div className={`relative flex flex-row items-center py-2`}>
        <LocationInput
          placeHolder={isDdropOffdifferent ? "Pickup Location" : "Location"}
          desc={isDdropOffdifferent ? "Location" : "Pickup & Dropoff Location"}
          className="flex-1 ps-2"
          sameDropOffLocation={dropoffLocationType === false}
          onShowDropoffLocation={() => setDropoffLocationType(false)}
        />
        {isDdropOffdifferent && (
          <>
            <div className="self-center border-r border-black h-8"></div>
            <DropOffLocationInput
              placeHolder="Dropoff Location"
              desc={"Location"}
              className="flex-1"
              divHideVerticalLineClass="-inset-x-0.5"
            />
          </>
        )}

        <div className="self-center border-r border-black h-8"></div>
        <StartDateTimeRange className="flex-1 w-[280px]" />

        <div className="self-center border-r border-black h-8"></div>
        <EndDateTimeRange
          className="flex-1 w-[280px]"
          dropOffLocationType={dropoffLocationType}
          design="designA"
        />
      </div>
    </form>
  );
};

export default RentalCarSearchForm;
